module.exports = __webpack_public_path__ + "img/welcome_stage.6392a01e.jpg";